import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import CompanyRegisterForm from '../Common/CompanyRegistration';

export default function CompanyRegistrationSimple() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Toggle function to open/close modal
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <Container className="p-0" fluid>
      <Row className="m-0">
        <Col xs={12} className="p-0">
          <div className="login-card login-dark">
            {/* Pass the closeModal function as a prop */}
            <CompanyRegisterForm closeModal={toggleModal} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
